export const version = '2.33.2';
//# sourceMappingURL=version.js.map